export default __webpack_public_path__ + "static/media/icon_timer_pause.ac5960ce.svg";